import api from './api';

/**
 * Audit Log service
 */
const auditService = {
    /**
     * Get all audit logs
     * @param {Object} params - Pagination, search, actor, target, method, status and date filters
     * @returns {Promise<Object>} Logs and pagination
     */
    async getLogs(params = {}) {
        const response = await api.get('/audit/logs', { params });
        return response.data;
    },

    /**
     * Get single log detail
     * @param {string} id - Log ID
     * @returns {Promise<Object>} Log detail
     */
    async getLogById(id) {
        const response = await api.get(`/audit/logs/${id}`);
        return response.data;
    },

    async getSettings() {
        const response = await api.get('/audit/settings');
        return response.data;
    },

    async updateSettings(data) {
        const response = await api.put('/audit/settings', data);
        return response.data;
    }
};

export default auditService;
